import React from 'react';

const Page = props => <section {...props} />;

export default Page;
